export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';

export const GOOGLE_AUTH_SUCCESS = 'GOOGLE_AUTH_SUCCESS';
export const GET_GOOGLE_USER = 'GET_GOOGLE_USER';
export const LOGOUT_GOOGLE_USER = 'LOGOUT_GOOGLE_USER';

export const REGISTER_LOCAL_USER = 'REGISTER_LOCAL_USER';
export const LOGIN_LOCAL_USER = 'LOGIN_LOCAL_USER';
export const LOGOUT_LOCAL_USER = 'LOGOUT_LOCAL_USER';
export const GET_LOCAL_USER = 'GET_LOCAL_USER';
export const REDIRECT_AFTER_LOGIN = 'REDIRECT_AFTER_LOGIN';